import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ThirdPartyForm_Organization_Memberships_Update_Mutation = graphql(`
  mutation ThirdPartyForm_Organization_Memberships_Update(
    $activeMemberships: [OrganizationMembershipInput!]!
    $organizationId: Id!
    $versionData: VersionDataInput
  ) {
    updateOrganizationMemberships(
      activeMemberships: $activeMemberships
      organizationId: $organizationId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useUpdateOrganizationMembershipsMutation = () =>
  useGraphQLMutation(ThirdPartyForm_Organization_Memberships_Update_Mutation);
